import { render } from "./TemplateChoosen.vue?vue&type=template&id=1908b86d&scoped=true"
import script from "./TemplateChoosen.vue?vue&type=script&lang=js"
export * from "./TemplateChoosen.vue?vue&type=script&lang=js"

import "./TemplateChoosen.vue?vue&type=style&index=0&id=1908b86d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1908b86d"]])

export default __exports__